export const DayforceIcon = ({ width = 18 }: { width?: number }) => {
  const height = Math.round((width * 25) / 18)

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0936 1.61296V8.65813C11.879 8.08967 10.5062 7.78913 9.00773 7.78913C7.27273 7.78913 5.71069 8.1681 4.35418 8.94236C2.99767 9.7003 1.92502 10.7588 1.15176 12.0697C0.394777 13.3805 0 14.8809 0 16.5241C0 18.1674 0.394777 19.6359 1.15176 20.9631C1.90873 22.2903 2.99767 23.348 4.35418 24.0904C5.71069 24.8328 7.27273 25.2273 8.99222 25.2273C10.7117 25.2273 12.2893 24.8483 13.6303 24.0904C14.9868 23.3324 16.0594 22.274 16.8172 20.9468C17.4842 19.7672 17.9371 18.2357 17.9526 17.0289C17.9526 17.0111 17.9526 0.00155317 17.9526 0.00155317L13.0936 1.61296ZM11.8068 19.6872C11.053 20.515 10.1323 20.9173 8.99455 20.9173C7.85675 20.9173 6.90898 20.5158 6.16674 19.6887C5.41209 18.85 5.04523 17.8133 5.04523 16.5179C5.04523 15.2226 5.41209 14.1532 6.16674 13.313C6.91053 12.4867 7.83504 12.0844 8.99455 12.0844C10.1323 12.086 11.0522 12.4882 11.8068 13.3161C12.5716 14.1548 12.9423 15.2032 12.9423 16.5195C12.9423 17.8358 12.5708 18.8492 11.8068 19.6872Z"
        fill="#3067DB"
      />
    </svg>
  )
}
